"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var defaults_1 = __importDefault(require("lodash/defaults"));
var BaseError_1 = require("./Errors/BaseError");
var SimpleAPIParserError_1 = require("./Errors/SimpleAPIParserError");
var TransportError_1 = require("./Errors/TransportError");
var SimpleAPIParser_1 = require("./SimpleAPIParser");
var SimpleAPIResponse_1 = require("./SimpleAPIResponse");
var SimpleAPIBaseManager = /** @class */ (function () {
    function SimpleAPIBaseManager() {
    }
    /**
     * Set the HTTP resource that will be used for all requests.
     * @param httpResource {AxiosInstance}
     */
    SimpleAPIBaseManager.setHttpResource = function (httpResource) {
        SimpleAPIBaseManager.httpResource = httpResource;
    };
    /**
     * Resolve options passed into a function.
     * @param options {[key:string]: any}
     * @param defaults {[key:string]: any}
     * @returns  {[key:string]: any}
     */
    SimpleAPIBaseManager.prototype.resolveOptions = function (options, defaults) {
        return defaults_1.default(options, defaults);
    };
    /**
     * Checks to see if the current value is a null value in any form.
     * @param value {any}
     * @returns {boolean} true if the value is a form of null.
     */
    SimpleAPIBaseManager.prototype.is_null = function (value) {
        return (value === null ||
            value === "null" ||
            typeof value === "undefined" ||
            value === undefined);
    };
    /**
     * Process a raw HTTP request.
     * @param options {AxiosRequestConfig}
     * @param httpInterface {AxiosInstance|null}
     * @returns {AxiosPromise<any>}
     */
    SimpleAPIBaseManager.prototype.http = function (options, httpInterface) {
        if (httpInterface === void 0) { httpInterface = null; }
        /*
         * If there's a custom Axios Instance provided, utilize that
         */
        if (httpInterface !== null && httpInterface instanceof axios_1.default) {
            return httpInterface.request(options);
        }
        else {
            /*
             * Otherwise, just use the standard one set on the base manager.
             */
            return SimpleAPIBaseManager.httpResource.request(options);
        }
    };
    /**
     * Validates a field ensuring its not blank
     * @param fieldName the label of the field
     * @param value the value of the field
     * @returns {String} a sanitized value
     */
    SimpleAPIBaseManager.prototype.notBlank = function (fieldName, value) {
        /*
         * If it's a number convert it to a string.
         */
        if (!isNaN(value)) {
            value = value.toString();
        }
        /*
         * If it's a string, trim it then check it's value
         */
        if (typeof value === "string") {
            value = value.trim();
            if (value === "") {
                throw new TypeError(fieldName + " must not be blank, '" + value + "' supplied.");
            }
        }
        return value;
    };
    /**
     *  Try to process a HTTP error.
     * @param err {AxiosError}
     */
    SimpleAPIBaseManager.prototype.processError = function (err) {
        var error = null;
        /*
         * If the error is an axios error, and the content type is not
         * json then it's most likely a transport error
         */
        if (err.hasOwnProperty("isAxiosError") &&
            err.hasOwnProperty("response") &&
            err.response.hasOwnProperty("headers") &&
            err.response.headers.hasOwnProperty("content-type") &&
            err.response.headers["content-type"] !== "application/json") {
            error = new TransportError_1.TransportError(err);
            /*
             * if the error has a response property then we have data, try to
             * resolve it as a SimpleAPIResponse
             */
        }
        else if (err.hasOwnProperty("response")) {
            error = SimpleAPIParser_1.SimpleAPIParserSingleton.resolve(err.response.data);
            /*
             * If its not a SimpleAPIResponse then there was a parsing error
             */
            if (!(error instanceof SimpleAPIResponse_1.SimpleAPIResponse)) {
                error = new SimpleAPIParserError_1.SimpleAPIParserError("Unable to parse SimpleAPIErrors", err.response);
            }
        }
        else {
            // If this level is reached, much probably it's an 500 error.
            error = new BaseError_1.BaseError("An Unresolvable error has occurred");
        }
        return error;
    };
    /**
     * Process a HTTP request.
     * @param options {AxiosRequestConfig}
     * @param httpInterface {AxiosInstance}
     * @returns {Promise<SimpleAPIResponse|SimpleAPIResponse[]>}
     * @fail {Promise<SimpleAPIResponse|BaseError>}
     */
    SimpleAPIBaseManager.prototype.apiCall = function (options, httpInterface) {
        var _this = this;
        if (httpInterface === void 0) { httpInterface = null; }
        return new Promise(function (resolve, reject) {
            /*
             * Run the HTTP request for the api call
             */
            _this.http(options, httpInterface)
                .then(function (res) {
                /*
                 * If the response only has an attributes property, resolve it as a single response
                 */
                if (res.data.hasOwnProperty("attributes")) {
                    resolve(SimpleAPIParser_1.SimpleAPIParserSingleton.resolve(res.data, true));
                }
                /*
                 * If the response has a data property, resolve it as a single response
                 */
                if (res.data.hasOwnProperty("data")) {
                    resolve(SimpleAPIParser_1.SimpleAPIParserSingleton.resolve(res.data));
                    /*
                     * If the response has a bulk property, resolve it as a bulk response
                     */
                }
                else if (res.data.hasOwnProperty("bulk")) {
                    resolve(SimpleAPIParser_1.SimpleAPIParserSingleton.resolveBulk(res.data));
                }
                else {
                    /*
                     * If we can't resolve it, then fail.
                     */
                    reject(new SimpleAPIParserError_1.SimpleAPIParserError("Response does not have a data or bulk attribute", res));
                }
            })
                .catch(function (err) {
                /*
                 * If there's an error, process it and return the result
                 */
                reject(_this.processError(err));
            });
        });
    };
    /**
     * This method will attempt to convert all boolean values to integers.
     * This is useful for symfony validation since it sees false as a non value.
     * @param options {object}
     */
    SimpleAPIBaseManager.prototype.convertBoolean = function (options) {
        if (typeof options === "boolean") {
            return options ? 1 : 0;
        }
        else if (options !== Object(options)) {
            return options;
        }
        for (var i in options) {
            if (options.hasOwnProperty(i)) {
                options[i] = this.convertBoolean(options[i]);
            }
        }
        return options;
    };
    return SimpleAPIBaseManager;
}());
exports.SimpleAPIBaseManager = SimpleAPIBaseManager;
//# sourceMappingURL=data:application/json;base64,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